/**
 * service.js
 */

// Import
import "./service.scss";
import $ from 'jquery';

$(document).ready(function() {

});

